<div class="embedded-sample-records-section mb-[40px]">
  <div class="sample-records-header flex justify-between items-center mb-[12px]">
    <div class="sample-records-label">Samples:</div>
  </div>

  @if (loading) {
    <div class="empty-row text-type-14">Loading&hellip;</div>
  } @else if (loadError) {
    <div class="empty-row text-type-14">{{ loadError }}</div>
  } @else if (!records?.length) {
    <div (click)="create()" class="sample-records-prompt flex flex-row items-center cursor-pointer">
      <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
      Add sample
    </div>
  } @else {
    <div class="sample-records-card">
      @for (row of records; track row.uuid) {
        <div (click)="rowClicked(row)" class="sample-row cursor-pointer">
          <div class="sample-row-main flex flex-row justify-between items-center gap-[12px]">
            <div class="sample-row-left flex flex-col">
              <div class="sample-id text-type-8">{{ row?.name || row?.sample_id || '(unnamed)' }}</div>
              <div class="sample-meta text-type-15">
                {{ row?.material_name || '-' }}
                @if (row?.ref_sample_status) {
                  <span> &bull; {{ row.ref_sample_status }}</span>
                }
              </div>
            </div>
            @if (row?.source_entity_id) {
              <div class="status-chip bg-approved txt-approved px-[10px] rounded-full">Pushed</div>
            }
          </div>
        </div>
      }
    </div>
    <div (click)="create()" class="add-more-link text-type-11 mt-[10px] cursor-pointer">
      + Create sample
    </div>
  }
</div>
